import React from "react";
import styles from "./ConversionRates.module.scss";
import { Col, Row } from "reactstrap";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

const ConversionRates = ({ conversionRatesData }) => {
    return (
        <div className={styles.conversionRateContainer}>
            {conversionRatesData.map((conversionRate, index) => (
                <Row key={index} className={styles.conversionRateRow}>
                    <Col className={styles.circularProgressBarColumn}>
                        <CircularProgressbar
                            value={conversionRate.percentageValue}
                            text={
                                <tspan>
                                    <tspan x="50%" dy="0em">{conversionRate.percentageValue}%</tspan>
                                </tspan>
                            }
                            strokeWidth={12}
                            styles={{
                                path: {
                                    stroke: conversionRate.color, // Set the path color
                                    strokeWidth: 12, // Set the width of the progress path (colored part)
                                },
                                trail: {
                                    stroke: conversionRate.color, // Set the trail color
                                    strokeWidth: 3, // Set the width of the trail (background part)
                                },
                                text: {
                                    fill: conversionRate.color,
                                    fontSize: "12px",
                                    fontWeight: "600",
                                    textAnchor: "middle", // Center the text
                                    dominantBaseline: "middle", // Align the text vertically in the middle
                                },
                            }}
                        />
                    </Col>
                    <Col>
                        <div>{conversionRate.content}</div>
                    </Col>
                </Row>
            ))}
        </div>
    );
};

export default ConversionRates;